import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

import FreeTrialTag from './Components/FreeTrialTag/FreeTrialTag'

const AI_STUDIO_PATH = '/ai'
const BRAND = 'CGTrader AI'
// Stands in for {{brand}} so the translated title can be split around the highlighted brand.
// Must not contain braces: i18next re-scans the interpolated string for further placeholders.
const BRAND_SLOT = '__BRAND__'

function AiCard() {
  const translate = useTranslate()
  const [titleBefore, titleAfter = ''] = translate('search_page.promo_cards.ai.title', { brand: BRAND_SLOT })
    .split(BRAND_SLOT)

  return (
    <div className="promo-card promo-card--ai">
      <div className="promo-card__text">
        <h3 className="promo-card__title cgt-heading-400">
          {titleBefore}
          <span className="promo-card__title-highlight">{BRAND}</span>
          {titleAfter}
        </h3>
        <p className="promo-card__description cgt-body-lg">
          {translate('search_page.promo_cards.ai.description')}
        </p>
      </div>
      <div className="promo-card__actions">
        <Button
          href={AI_STUDIO_PATH}
          type="ai-primary"
          size="medium"
          customClass="promo-card__button"
        >
          {translate('search_page.promo_cards.ai.cta')}
        </Button>
        <FreeTrialTag />
      </div>
    </div>
  )
}

export default AiCard
